import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const StockIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="13" width="8" height="7" rx="1" />
      <rect x="13" y="13" width="8" height="7" rx="1" />
      <rect x="8" y="4" width="8" height="7" rx="1" />
      <path d="M7 13v2.5M17 13v2.5M12 4v2.5M2 22h20" />
    </g>
  </SvgIcon>
)

export default StockIcon
